import DataQuery from 'data/DataQuery';
import { ParentCompany_GetParentCompany } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import React from 'react';
import ParentCompanyDTO from 'features/parentCompany/dtos/ParentCompanyDTO';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import SubjectInfoCard from 'features/customer/components/SubjectInfoCard';
import { useTranslation } from 'react-i18next';
import ParentCompanySupplierContact from '../components/ParentCompanySupplierContact';

type Props = {}

const ParentCompanySection = (props: Props) => {
  // translations
  const tLabels = useTranslation("parentCompany\\parentCompany").t;

  // fetch data
  const query: DataQuery = {
    url: ParentCompany_GetParentCompany
  };
  const { data: parentCompany, loadStatus } = useQuery<ParentCompanyDTO>(query, {});

  return (
    <NoContentWrapper
      data={parentCompany}
      loadStatus={loadStatus}
      noContentAsAlert
    >
      <h4 className="text-muted">{tLabels("parentCompanySection.supplier")}</h4>
      <SubjectInfoCard 
        subjectType="Company"
        subjectTypeIcon="building"
        subjectName={parentCompany.company?.name!}
        company={parentCompany.company}
        subjectAddress={parentCompany.address!}
        renderOtherInfo={() => <ParentCompanySupplierContact contact={parentCompany} />}
        className="pb-0"
      />
    </NoContentWrapper>
  )
}

export default ParentCompanySection;